import { AxleOrgSyncOrgFragment } from "../../../../../../types";
import { CardMode } from "./DisplayCard";
import { DisplayList, RenderListItemArgs } from "./DisplayList";
import { OrgCard } from "./OrgCard";

export interface OrgsListBaseProps {
  selectedId: string | null;
  orgs: readonly AxleOrgSyncOrgFragment[];
  loading: boolean;
  title: string;
  columnMode: CardMode;
  total?: number;
  hasNextPage?: boolean;
  onLoadMore?: () => void;
  loadingMore?: boolean;
  onLink?: (org: AxleOrgSyncOrgFragment) => void;
  onSync?: (org: AxleOrgSyncOrgFragment) => void;
  onRetryBatch?: (org: AxleOrgSyncOrgFragment, batchIndex: number) => void;
  retryingBatchIndex?: number | null;
  onClick?: (org: AxleOrgSyncOrgFragment) => void;
}

export const OrgsListBase = ({
  selectedId,
  orgs,
  loading,
  title,
  columnMode,
  total,
  hasNextPage,
  onLoadMore,
  loadingMore,
  onSync,
  onRetryBatch,
  retryingBatchIndex,
  onClick,
}: OrgsListBaseProps) => {
  const renderListItem = ({ key, ...restProps }: RenderListItemArgs<AxleOrgSyncOrgFragment>) => {
    return (
      <OrgCard
        key={key}
        onSync={onSync}
        onRetryBatch={onRetryBatch}
        retryingBatchIndex={retryingBatchIndex}
        onClick={onClick}
        {...restProps}
      />
    );
  };

  return (
    <DisplayList
      title={total === undefined ? title : `${title} (${total})`}
      columnMode={columnMode}
      renderListItem={renderListItem}
      elements={orgs}
      disabled={selectedId !== null}
      loading={loading}
      selectedId={selectedId}
      hasNextPage={hasNextPage}
      onLoadMore={onLoadMore}
      loadingMore={loadingMore}
    />
  );
};
